/**
 * Weyzen Bundle & Subscription Module
 */

(function() {
  'use strict';

  // Initialisation au chargement du DOM
  function init() {
    const modules = document.querySelectorAll('.custom-sub-module');

    modules.forEach(module => {
      if (module.dataset.initialized === 'true') return;

      const blockId = module.dataset.blockId;
      if (!blockId) {
        console.warn('Bundle module missing data-block-id');
        return;
      }

      setupModule(blockId);
      module.dataset.initialized = 'true';
    });
  }

  function setupModule(blockId) {
    // Trouver le module parent
    const module = document.querySelector(`.custom-sub-module[data-block-id="${blockId}"]`);
    if (!module) {
      console.warn(`Bundle module with block ID ${blockId} not found`);
      return;
    }

    // Éléments principaux
    const oneTimeRadio = document.getElementById(`custom-sub-module--one-time__input-${blockId}`);
    const subRadio = document.getElementById(`custom-sub-module--subscription__input-${blockId}`);
    const oneTimeLabel = document.querySelector(`label[for="custom-sub-module--one-time__input-${blockId}"]`);
    const subLabel = document.querySelector(`label[for="custom-sub-module--subscription__input-${blockId}"]`);

    // Conteneurs (scoped au module)
    const oneTimeContainer = module.querySelector('.custom-sub-module--one-time-purchase__variants-wrapper');
    const subContainer = module.querySelector('.custom-sub-module--suscription-purchase__content');

    // Select et offres (scoped au module)
    const frequencySelect = document.getElementById(`custom-sub-module--subscription-purchase__select-${blockId}`);
    const offerRadios = module.querySelectorAll(`.custom-sub-module--one-time-purchase__variant-input`);

    // Formulaire produit Shopify
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const quantityInput = productForm?.querySelector('input[name="quantity"]');
    let sellingPlanInput = productForm?.querySelector('input[name="selling_plan"]');

    // Créer le champ selling_plan s'il n'existe pas
    if (productForm && !sellingPlanInput) {
      sellingPlanInput = document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      productForm.appendChild(sellingPlanInput);
    }

    // Vérification que l'achat unique existe au minimum
    if (!oneTimeRadio) {
      console.warn(`Bundle module ${blockId}: Missing one-time radio button`);
      return;
    }

    // Si seul l'achat unique est activé
    if (!subRadio) {
      console.log(`Module ${blockId}: Only one-time purchase mode enabled.`);
      // Forcer l'achat unique comme sélectionné
      oneTimeRadio.checked = true;
      handlePurchaseTypeChange('one-time');
    } else {
      console.log(`Bundle module ${blockId} initialized successfully`);
    }

    // ===== GESTION DU TOGGLE ACHAT UNIQUE / ABONNEMENT =====

    function handlePurchaseTypeChange(type) {
      if (type === 'one-time') {
        // Activer Achat unique
        oneTimeLabel?.classList.add('custom-sub-module-label--selected');
        subLabel?.classList.remove('custom-sub-module-label--selected');

        // Déplier achat unique, plier abonnement
        oneTimeContainer?.classList.remove('custom-sub-module--purchase-type__content-hidden');
        oneTimeContainer?.classList.add('custom-sub-module--purchase-type__content-visible');
        subContainer?.classList.add('custom-sub-module--purchase-type__content-hidden');
        subContainer?.classList.remove('custom-sub-module--purchase-type__content-visible');

        // Afficher les selects de variantes achat unique
        const oneTimeVariantSelectors = module.querySelector('.custom-sub-module--one-time__variant-selectors-container');
        if (oneTimeVariantSelectors) {
          oneTimeVariantSelectors.style.display = 'block';
        }

        // Cacher les selects de variantes abonnement
        const subVariantSelectors = module.querySelector('.custom-sub-module--subscription__variant-selectors-container');
        if (subVariantSelectors) {
          subVariantSelectors.style.display = 'none';
        }

        // Retirer le selling plan
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
        }

        // Mettre à jour la quantité selon l'offre sélectionnée
        updateQuantityFromOffer();

      } else if (type === 'subscription') {
        // Activer Abonnement
        subLabel?.classList.add('custom-sub-module-label--selected');
        oneTimeLabel?.classList.remove('custom-sub-module-label--selected');

        // Plier achat unique, déplier abonnement
        oneTimeContainer?.classList.add('custom-sub-module--purchase-type__content-hidden');
        oneTimeContainer?.classList.remove('custom-sub-module--purchase-type__content-visible');
        subContainer?.classList.remove('custom-sub-module--purchase-type__content-hidden');
        subContainer?.classList.add('custom-sub-module--purchase-type__content-visible');

        // Cacher les selects de variantes achat unique
        const oneTimeVariantSelectors = module.querySelector('.custom-sub-module--one-time__variant-selectors-container');
        if (oneTimeVariantSelectors) {
          oneTimeVariantSelectors.style.display = 'none';
        }

        // Cacher le sélecteur de variante abonnement au début (il s'affichera après sélection de fréquence)
        const subVariantSelectors = module.querySelector('.custom-sub-module--subscription__variant-selectors-container');
        if (subVariantSelectors) {
          subVariantSelectors.style.display = 'none';
        }

        // Réinitialiser le select et les prix
        if (frequencySelect) {
          frequencySelect.selectedIndex = 0;
        }
        hideAllPrices();

        // Quantité à 1 pour abonnement
        if (quantityInput) {
          quantityInput.value = 1;
        }
      }
    }

    // Events sur les radios principaux
    oneTimeRadio.addEventListener('change', () => {
      if (oneTimeRadio.checked) {
        handlePurchaseTypeChange('one-time');
      }
    });

    // Seulement ajouter l'event listener si l'abonnement existe
    if (subRadio) {
      subRadio.addEventListener('change', () => {
        if (subRadio.checked) {
          handlePurchaseTypeChange('subscription');
        }
      });
    }

    // ===== GESTION DES OFFRES (1x, 2x, 3x) =====

    function updateQuantityFromOffer() {
      const selectedOffer = module.querySelector('.custom-sub-module--one-time-purchase__variant-input:checked');
      if (selectedOffer && quantityInput) {
        const quantity = selectedOffer.dataset.quantity;
        quantityInput.value = quantity;

        // Trigger change event
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    offerRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        // Mise à jour visuelle (scoped au module)
        module.querySelectorAll('.custom-sub-module--one-time-purchase__variant-label').forEach(label => {
          label.classList.remove('custom-sub-module--one-time-purchase__variant-label--selected');
        });

        const label = e.target.nextElementSibling;
        if (label) {
          label.classList.add('custom-sub-module--one-time-purchase__variant-label--selected');
        }

        // Mise à jour de la quantité
        if (oneTimeRadio?.checked) {
          updateQuantityFromOffer();
        }

        // Afficher les selects de variantes correspondants
        const quantity = e.target.dataset.quantity;
        showVariantSelectorsForQuantity(quantity);
      });
    });

    // ===== GESTION DES SELECTS DE VARIANTES =====

    function showVariantSelectorsForQuantity(quantity) {
      // Cacher tous les groupes de selects
      module.querySelectorAll('.custom-sub-module--one-time__variant-selectors-group').forEach(group => {
        group.style.display = 'none';
      });

      // Afficher le groupe correspondant à la quantité
      const activeGroup = module.querySelector(`.custom-sub-module--one-time__variant-selectors-group[data-quantity="${quantity}"]`);
      if (activeGroup) {
        activeGroup.style.display = 'flex';
      }
    }

    const variantSelects = module.querySelectorAll('.custom-sub-module--one-time__variant-selector');

    // Fonction pour mettre à jour la couleur du swatch
    function updateColorSwatch(select) {
      const selectedOption = select.options[select.selectedIndex];
      const color = selectedOption.dataset.color;
      const wrapper = select.parentElement;

      if (color && wrapper) {
        wrapper.style.setProperty('--swatch-color', color);
      }
    }

    variantSelects.forEach(select => {
      // Initialiser la couleur au chargement
      updateColorSwatch(select);

      select.addEventListener('change', (e) => {
        console.log(`Variante sélectionnée: ${e.target.value} pour ${e.target.dataset.quantityIndex}x produit #${e.target.dataset.variantIndex}`);
        updateColorSwatch(e.target);
        updateVariantIdInput();
      });
    });

    // Fonction pour collecter toutes les variantes sélectionnées
    function getSelectedVariants() {
      const selectedOffer = module.querySelector('.custom-sub-module--one-time-purchase__variant-input:checked');
      if (!selectedOffer) return [];

      const quantity = parseInt(selectedOffer.dataset.quantity);
      const activeGroup = module.querySelector(`.custom-sub-module--one-time__variant-selectors-group[data-quantity="${quantity}"]`);

      const variants = [];

      // Si pas de groupe de selects (produit avec une seule variante)
      if (!activeGroup) {
        // Utiliser la variante du formulaire principal
        const variantIdInput = productForm?.querySelector('input[name="id"]');
        const variantId = variantIdInput?.value;

        if (variantId) {
          // Ajouter la variante autant de fois que la quantité
          for (let i = 0; i < quantity; i++) {
            variants.push({
              id: variantId,
              quantity: 1
            });
          }
        }
        return variants;
      }

      // Si groupe de selects existe (produit avec plusieurs variantes)
      const selects = activeGroup.querySelectorAll('.custom-sub-module--one-time__variant-selector');
      selects.forEach(select => {
        if (select.value) {
          variants.push({
            id: select.value,
            quantity: 1
          });
        }
      });

      return variants;
    }

    // Mettre à jour le champ variant_id du formulaire avec la variante sélectionnée
    function updateVariantIdInput() {
      const variants = getSelectedVariants();
      if (variants.length === 1) {
        // Pour x1, mettre à jour l'input id du formulaire
        const variantIdInput = productForm?.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = variants[0].id;
        }
      }
    }

    // Intercepter l'ajout au panier
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        // Seulement intercepter si achat unique est sélectionné
        if (!oneTimeRadio?.checked) return;

        const variants = getSelectedVariants();

        // Récupérer le produit cadeau si il existe
        const selectedLabel = module.querySelector('.custom-sub-module--one-time-purchase__variant-label--selected');
        const giftVariantId = selectedLabel?.dataset.giftVariantId;

        // Pour x1 sans cadeau, laisser le formulaire normal gérer l'ajout
        if (variants.length === 1 && !giftVariantId) {
          updateVariantIdInput();
          return;
        }

        // Pour x2/x3 ou x1 avec cadeau, intercepter et utiliser l'API
        e.preventDefault();
        e.stopPropagation();

        try {
          // Si un produit cadeau est configuré, l'ajouter
          if (giftVariantId) {
            variants.push({
              id: giftVariantId,
              quantity: 1
            });
          }

          console.log('Ajout au panier - variants:', variants);

          // Ajouter tous les items au panier via l'API
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: variants })
          });

          if (response.ok) {
            const data = await response.json();

            // Déclencher les événements du thème pour gérer le panier et ouvrir le drawer
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('product-ajax:added', {
              detail: {
                product: data,
              },
            }));
          } else {
            const errorData = await response.json();
            console.error('Erreur lors de l\'ajout au panier:', response.status, errorData);
            alert('Erreur lors de l\'ajout au panier: ' + (errorData.description || errorData.message || 'Erreur inconnue'));
          }
        } catch (error) {
          console.error('Erreur:', error);
        }
      }, true); // Capture phase pour intercepter avant les autres handlers
    }

    // ===== GESTION DU SELECT FRÉQUENCE ABONNEMENT =====

    function hideAllPrices() {
      module.querySelectorAll('.custom-sub-module--subscription-purchase__economy').forEach(el => {
        el.style.display = 'none';
      });
      module.querySelectorAll('.custom-sub-module--subscription-purchase__prices').forEach(el => {
        el.style.display = 'none';
      });
      module.querySelectorAll('.custom-sub-module--subscription-purchase__economy--inline').forEach(el => {
        el.style.display = 'none';
      });
    }

    function showPricesForIndex(index) {
      hideAllPrices();

      if (index > 0) {
        // Toujours afficher les prix dans le select (data-index="1")
        module.querySelectorAll(`.custom-sub-module--subscription-purchase__economy[data-index="1"]`).forEach(el => {
          el.style.display = '';
        });
        module.querySelectorAll(`.custom-sub-module--subscription-purchase__prices[data-index="1"]`).forEach(el => {
          el.style.display = '';
        });

        // Afficher l'économie inline
        const inlineEconomy = module.querySelector('.custom-sub-module--subscription-purchase__economy--inline[data-index="1"]');
        if (inlineEconomy) {
          inlineEconomy.style.display = '';
        }
      }
    }

    // Seulement si le select existe
    if (frequencySelect) {
      frequencySelect.addEventListener('change', (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const planId = selectedOption.dataset.planId;
        const index = selectedOption.dataset.index;

        // Mettre à jour le selling_plan
        if (planId && sellingPlanInput) {
          sellingPlanInput.value = planId;
        }

        // Afficher les prix correspondants
        if (index) {
          showPricesForIndex(parseInt(index, 10));
        }

        // Afficher le sélecteur de variante si une fréquence est sélectionnée
        const subVariantSelectors = module.querySelector('.custom-sub-module--subscription__variant-selectors-container');
        if (subVariantSelectors) {
          if (index > 0) {
            subVariantSelectors.style.display = 'block';
          } else {
            subVariantSelectors.style.display = 'none';
          }
        }

        // Quantité à 1 pour abonnement
        if (quantityInput) {
          quantityInput.value = 1;
        }
      });
    }

    // ===== GESTION DU SÉLECTEUR DE VARIANTE ABONNEMENT =====

    const subscriptionVariantSelect = module.querySelector('.custom-sub-module--subscription__variant-selector');

    if (subscriptionVariantSelect) {
      // Fonction pour mettre à jour la couleur du swatch abonnement
      function updateSubscriptionColorSwatch(select) {
        const selectedOption = select.options[select.selectedIndex];
        const color = selectedOption.dataset.color;
        const wrapper = select.parentElement;

        if (color && wrapper) {
          wrapper.style.setProperty('--swatch-color', color);
        }
      }

      // Initialiser la couleur au chargement
      updateSubscriptionColorSwatch(subscriptionVariantSelect);

      subscriptionVariantSelect.addEventListener('change', (e) => {
        // Mettre à jour l'input id du formulaire
        const variantIdInput = productForm?.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = e.target.value;
        }
        console.log(`Variante abonnement sélectionnée: ${e.target.value}`);
        updateSubscriptionColorSwatch(e.target);
      });
    }

    // ===== GESTION DE LA MODAL =====

    const modalTrigger = document.querySelector(`[data-modal-trigger="bundle-info-${blockId}"]`);
    const modal = document.getElementById(`bundle-info-${blockId}`);

    if (modalTrigger && modal) {
      modalTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        modal.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
      });

      const closeBtn = modal.querySelector(`#ModalClose-${blockId}`);
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          modal.removeAttribute('open');
          document.body.style.overflow = '';
        });
      }

      // Fermer sur clic overlay
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.removeAttribute('open');
          document.body.style.overflow = '';
        }
      });

      // Fermer avec ESC
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.hasAttribute('open')) {
          modal.removeAttribute('open');
          document.body.style.overflow = '';
        }
      });
    }

    // ===== INITIALISATION =====

    // Initialiser avec la quantité de l'offre par défaut
    updateQuantityFromOffer();

    // Masquer les prix au démarrage
    hideAllPrices();

    // Afficher les selects de variantes pour l'offre cochée par défaut
    const defaultCheckedOffer = module.querySelector('.custom-sub-module--one-time-purchase__variant-input:checked');
    if (defaultCheckedOffer) {
      const defaultQuantity = defaultCheckedOffer.dataset.quantity;
      showVariantSelectorsForQuantity(defaultQuantity);
    }
  }

  // Initialisation au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ré-initialisation lors du rechargement de section Shopify
  document.addEventListener('shopify:section:load', function(event) {
    setTimeout(init, 100);
  });

})();